import { render } from "./BreadcrumbNav.vue?vue&type=template&id=a2df6d9a&scoped=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js"

import "./BreadcrumbNav.vue?vue&type=style&index=0&id=a2df6d9a&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2df6d9a"]])

export default __exports__